var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleLineExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 86,
    viewBox: "0 0 114 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 0L57 50",
    stroke: "#7043FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 50,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E3E3E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.818 62.9214C62.0894 63.1789 62.1007 63.6076 61.8432 63.879L57.9578 67.9744L62.0531 71.8598C62.3246 72.1172 62.3358 72.546 62.0783 72.8174C61.8208 73.0889 61.3921 73.1001 61.1207 72.8426L57.0253 68.9573L53.14 73.0526C52.8825 73.324 52.4537 73.3353 52.1823 73.0778C51.9109 72.8203 51.8996 72.3915 52.1571 72.1201L56.0424 68.0248L51.9471 64.1394C51.6757 63.8819 51.6644 63.4532 51.9219 63.1817C52.1794 62.9103 52.6082 62.899 52.8796 63.1565L56.9749 67.0419L60.8603 62.9466C61.1178 62.6751 61.5466 62.6639 61.818 62.9214Z",
    fill: "#979797",
    stroke: "#979797",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9175 71.5234V73H86.6265V71.5234H91.9175ZM87.2007 63.0469V73H85.3208V63.0469H87.2007ZM91.227 67.1553V68.5977H86.6265V67.1553H91.227ZM91.897 63.0469V64.5303H86.6265V63.0469H91.897ZM94.7342 63.0469L96.7235 66.5947L98.7196 63.0469H100.88L97.9266 67.9824L100.955 73H98.7743L96.7235 69.3838L94.6795 73H92.492L95.5203 67.9824L92.5672 63.0469H94.7342ZM104.127 63.0469V73H102.247V63.0469H104.127ZM110.239 63.0469V73H108.366V63.0469H110.239ZM113.329 63.0469V64.5303H105.31V63.0469H113.329Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleLineExit);
export default __webpack_public_path__ + "static/media/purple_line_exit.d79f4c39c5031b18f3140c0be991d438.svg";
export { ForwardRef as ReactComponent };